import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-slate max-w-none">
          <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">Protección de datos personales</h2>
          
          <p className="text-slate-600 mb-4">
            No se recogen datos personales directamente a través del Sitio, salvo los necesarios mediante cookies técnicas.
          </p>

          <p className="text-slate-600 mb-4">
            Solo se procesan datos técnicos relacionados con la navegación, conforme a la política de cookies del Sitio.
          </p>

          <p className="text-slate-600 mb-4">
            Conforme al Reglamento General de Protección de Datos (UE) 2016/679 y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), los derechos de acceso, rectificación, supresión, oposición o portabilidad pueden ejercerse enviando un correo electrónico a: <a href="mailto:info@agencia-ppc.es" className="text-blue-600 hover:underline">info@agencia-ppc.es</a>
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Responsable del tratamiento</h3>
          <p className="text-slate-600 mb-4">
            El responsable del tratamiento es Ulysse Julien Berneau, empresario individual registrado como Autónomo en España bajo el régimen RETA (NIE: Y5618264E), con domicilio en Calle Castillejos 276, SA2A, 08025 Barcelona.
          </p>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Derechos del usuario</h3>
          <p className="text-slate-600 mb-2">El usuario tiene derecho a:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
            <li>Acceder a sus datos personales</li>
            <li>Rectificar los datos inexactos</li>
            <li>Solicitar la supresión de sus datos</li>
            <li>Oponerse al tratamiento de sus datos</li>
            <li>Solicitar la portabilidad de sus datos</li>
          </ul>

          <h3 className="text-lg font-semibold text-slate-800 mt-6 mb-3">Contacto</h3>
          <p className="text-slate-600 mb-4">
            Para ejercer cualquiera de estos derechos o para cualquier consulta relacionada con la protección de datos, puede contactar con nosotros en: <a href="mailto:info@agencia-ppc.es" className="text-blue-600 hover:underline">info@agencia-ppc.es</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
